









































































































































































































import { Component, Mixins, Watch, Ref } from 'vue-property-decorator';
import CRUDMixins from '@/mixins/CRUDMixins';
import BodyMapMixins from '@/mixins/BodyMapMixins';
import TransitionMixins from '@/mixins/TransitionMixins';
import AnzscoOccupationSelect from '@/components/RiskProfile/AnzscoOccupationSelect.vue';
import RiskProfileTemplateSelect from '@/components/RiskProfile/RiskProfileTemplateSelect.vue';
import RiskProfileOptions from '@/components/RiskProfile/RiskProfileOptions.vue';
import RiskProfileCreateBasicInfo from './Create/RiskProfileCreateBasicInfo.vue';

import { mapState, mapGetters } from 'vuex';
import { STATUSES } from '@/constants/risk_profile';

@Component({
  components: {
    AnzscoOccupationSelect,
    RiskProfileTemplateSelect,
    RiskProfileOptions,
    RiskProfileCreateBasicInfo,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('RiskProfileTemplate', {
      selectedTemplate: 'selectedTemplate',
      riskProfileTree: 'riskProfileTree',
    }),
    ...mapState('Anzsco', {
      selectedOccupation: 'selectedOccupation',
    }),
    ...mapState('RiskProfile', {
      riskProfile: 'riskProfile',
      newRiskProfile: 'newRiskProfile',
      questionGroups: 'questionGroups',
      extraQuestionGroups: 'extraQuestionGroups',
      bodyParts: 'bodyParts', // is used in BodyMapMixins
    }),
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
    ...mapGetters('RiskProfile', {
      enabledRiskProfileItems: 'enabledRiskProfileItems',
      enabledQuestionGroups: 'enabledQuestionGroups',
      availableQuestionGroups: 'availableQuestionGroups',
      bodyPartPreviewItems: 'bodyPartPreviewItems',
    }),
  },
})
export default class RiskProfileCreate extends Mixins(
  CRUDMixins,
  BodyMapMixins,
  TransitionMixins
) {
  @Ref() readonly step_2!: { validate: (any?: any) => boolean };

  // RiskProfile State
  selectedOccupation!: Model;
  selectedTemplate!: Model;
  riskProfile!: Model;
  newRiskProfile!: NewRiskProfile;
  riskProfileTree!: [];
  questionGroups!: [];
  extraQuestionGroups!: [];

  // Business State
  business!: Model;

  // Getters
  enabledRiskProfileItems!: {
    object_id: string;
    edge_is_enabled: boolean;
    edge_how_often: any;
    edge_extform_value: any;
    title: string;
  }[];
  enabledQuestionGroups!: [];
  availableQuestionGroups!: [];
  bodyPartPreviewItems!: [];
  selectedQuestionGroups = [];

  // Data
  statuses = STATUSES;
  currentStep = 0;
  showPreview = false;
  showPreviewButton = true;
  questionGroupDescription =
    'Here is the list of the question groups the individual will complete which will provide the relevant information in their report.';
  isBasicInfoValid = false;

  // Computed
  get riskProfileVal() {
    return this.newRiskProfile;
  }
  set riskProfileVal(v) {
    this.$store.commit('RiskProfile/SET_NEW_RISK_PROFILE', v);
  }

  get sortedRiskProfileItem() {
    return this.enabledRiskProfileItems.sort((a, b) => {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    });
  }

  get steps() {
    return [
      {
        title: 'Step 1',
        subtitle: 'What is the job title?',
        description:
          "<p>Use our Search function to find the required job title. On the next page, Quescreen will select the most appropriate Risk Profile Template.</p><p class='secondary--text'>Please note: If your specific job title is not available, choose another title that aligns with the duties required. </p>",
        canProceed: () => this.selectedOccupation !== null,
      },
      {
        title: 'Step 2',
        subtitle: 'We suggest this Risk Profile Template',
        description:
          '<p>Select the template available which is relevant to the job role. Our Risk Profile Template will provide pre-selected requirements for the position and a list of potential risks to an individual performing duties of the role.</p>',
        canProceed: () =>
          this.selectedTemplate && this.selectedTemplate.object_id,
      },
      {
        title: 'Step 3',
        subtitle: 'Customise the Risk Profile Template',
        description:
          '<p>Please click on each category (on the left) to choose specific risk items that relate to the job role. </p><p>By identifying specific risk items you can create an extensive job profile to match your organisational needs. Your tailored Risk Profile will be saved and easily accessible for future edits and purchases.  ',
        canProceed: () => this.enabledRiskProfileItems.length > 0,
      },
      {
        title: 'Step 4',
        subtitle: 'Additional Question Groups',
        description:
          '<p>Are any of the question groups below relevant to your job role? If so, please select individual group(s) for inclusion in the Quescreen Questionnaire to be completed by the individual(s).</p><p>These questions could provide further information about the individual(s) suitability for the job role.',
      },
      {
        title: 'Step 5',
        subtitle: 'Customise the Job Description',
        description:
          ' Would you like to customise the Job Description? This will be viewed by the individual(s) you allocate the Quescreen to. Click anywhere in the description to make edits.</p><p>By clicking Next, you can view the finalised job description, the list of the question groups Quescreen has selected, (along with any additions selected) for the individual(s) to complete, and a human body image highlighting areas of risk for this job role.</p>',
        canProceed: () =>
          this.riskProfileVal.custom_job_role_name &&
          this.riskProfileVal.custom_job_role_name.length > 0,
      },
      {
        title: 'Step 6',
        subtitle: 'Review and Publish',
        description:
          '<p>You\'re almost set!</p><p>Please review and select "Publish" to save this Quescreen and proceed to purchase.</p>',
        canProceed: () => true,
      },
    ];
  }

  // BeforeMount
  beforeMount() {
    this.$store.commit('Anzsco/CLEAR_STATE');
    // this.business.object_id = this.$route.params.businessOid
  }

  // Watch
  @Watch('selectedQuestionGroups')
  updateExtraQuestionGroups(v) {
    if (v) {
      const selectedQuestionGroups =
        this.questionGroups.filter((item: Model) => v.includes(item.id)) || [];
      const questionGroupOids =
        selectedQuestionGroups.map((item: Model) => {
          return item.object_id || '';
        }) || [];
      this.$store.commit(
        'RiskProfile/SET_EXTRA_QUESTION_GROUPS',
        questionGroupOids
      );
    }
  }
  @Watch('currentStep', { immediate: true })
  watchCurrentStep(newVal) {
    if (newVal === 5) {
      this.$emit('disable-actions', ['']);
    } else {
      this.$emit('disable-actions', ['CREATE', 'UPDATE']);
    }
  }

  // Methods
  async navigate(selected, step, done) {
    switch (step) {
      case 2:
        if (!this.riskProfileTree) {
          await this.$store.dispatch(
            'RiskProfileTemplate/fetchFullRiskProfileTemplate',
            this.selectedTemplate.object_id
          );
        }
        break;
      case 3:
        if (this.step_2 && !this.step_2.validate()) {
          return;
        }
        break;
      case 4:
        if (
          this.selectedOccupation &&
          !this.newRiskProfile.custom_job_role_name
        ) {
          this.newRiskProfile.custom_job_role_name =
            this.selectedOccupation.name || '';
          this.newRiskProfile.description =
            this.selectedOccupation.job_description || '';
        }
        break;
    }

    this.currentStep = step;

    this.showPreviewButton = step < 5;
    if (!this.showPreviewButton) {
      this.showPreview = false;
    }

    done();
  }

  create() {
    this.update(STATUSES.STATUS_PUBLISHED.key);
  }

  update(status = STATUSES.STATUS_DRAFT.key) {
    this.newRiskProfile.status = status;
    this.newRiskProfile.anzsco_oid = this.selectedOccupation.object_id;
    this.newRiskProfile.rpt_oid = this.selectedTemplate.object_id;
    this.newRiskProfile.business_oid = this.business.object_id;
    this.newRiskProfile.risk_profile_items = this.enabledRiskProfileItems;
    this.newRiskProfile.extra_question_groups = this.extraQuestionGroups;

    this.$store
      .dispatch('RiskProfile/create', this.newRiskProfile)
      .then((res) => {
        if (res) {
          if (this.newRiskProfile.status === this.statuses.STATUS_DRAFT.key) {
            this.$router.push({
              name: 'business-risk-profile-list',
            });
          } else {
            this.$router.push({
              name: 'business-risk-profile-read',
              params: {
                riskProfileOid: this.riskProfile.object_id || '',
              },
            });
          }
        }
      });
  }

  // BeforeDestroy
  beforeDestroy() {
    this.$store.commit('Anzsco/CLEAR_STATE');
    this.$store.commit('RiskProfile/CLEAR_STATE');
    this.$store.commit('RiskProfileTemplate/CLEAR_STATE');
  }
}
